import axios from '@/utils/request'

/* 首页数据 */
export function index(data) {
  return axios({
    url: '/index/index',
    method: 'post',
    data: data
  })
}

/* 首页公告 */
export function notice(data) {
  return axios({
    url: '/article/articlelists',
    method: 'post',
    data: data
  })
}

/* 首页公告详情 */
export function noticeDetail(data) {
  return axios({
    url: '/article/detail',
    method: 'post',
    data: data
  })
}

/* 首页快速菜单 */
export function homeMenu(data) {
  return axios({
    url: '/user/homepage_menu',
    method: 'post',
    data: data
  })
}

/* 首页快速菜单编辑 */
export function updateMenu(data) {
  return axios({
    url: '/user/update_homepage_menu',
    method: 'post',
    data: data
  })
}

/* 游戏详情 */
export function gameDetail(data) {
  return axios({
    url: '/game/game_detail',
    method: 'post',
    data: data
  })
}

/* 游戏推广二维码 */
export function gameCode(data) {
  return axios({
    url: '/game/game_promotion',
    method: 'post',
    data: data
  })
}

/* 游戏开服 */
export function gameOpen(data) {
  return axios({
    url: '/game/game_detail_server',
    method: 'post',
    data: data
  })
}

/* 游戏活动 */
export function detailArticle(data) {
  return axios({
    url: '/game/game_detail_article',
    method: 'post',
    data: data
  })
}


/* 游戏礼包 */
export function detailGiftbag(data) {
  return axios({
    url: '/game/game_detail_giftbag',
    method: 'post',
    data: data
  })
}

/* 玩家列表 */
export function register(data) {
  return axios({
    url: '/query/register',
    method: 'post',
    data: data
  })
}

/* 选择渠道 */
export function childPromotes(url, data) {
  return axios({
    url: url,
    method: 'post',
    data: data
  })
}

/* 选择游戏 */
export function searchGame(data, url) {
  return axios({
    url: url,
    method: 'post',
    data: data
  })
}

/* 玩家列表登录记录 */
export function logRecored(data) {
  return axios({
    url: '/user/user_login_record',
    method: 'post',
    data: data
  })
}
/* 玩家列表角色记录 */
export function roleRecored(data) {
  return axios({
    url: '/query/role',
    method: 'post',
    data: data
  })
}
/* 玩家列表查凸凸币 */
export function bhCoinRecord(data) {
  return axios({
    url: '/user/user_bhCoin_record',
    method: 'post',
    data: data
  })
}

/* 玩家充值列表 */
export function recharge(data) {
  return axios({
    url: '/query/recharge',
    method: 'post',
    data: data
  })
}

/* 新游首发 */
export function newGame(data) {
  return axios({
    url: '/index/get_today_newgame',
    method: 'post',
    data: data
  })
}

/* 新游首发 */
export function articleList(data) {
  return axios({
    url: '/query/article_list',
    method: 'post',
    data: data
  })
}

/* 活动详情 */
export function articleDetail(data) {
  return axios({
    url: '/query/article_detail',
    method: 'post',
    data: data
  })
}

/* 归属查询 */
export function queryBelong(data) {
  return axios({
    url: '/sub_channel/query_player_belong',
    method: 'post',
    data: data
  })
}

/* 开服信息 */
export function serverList(data) {
  return axios({
    url: '/query/server_list',
    method: 'post',
    data: data
  })
}

/* 钓鱼查询 */
export function fishingList(data) {
  return axios({
    url: '/query/fishing_list',
    method: 'post',
    data: data
  })
}

/* 礼包查询 */
export function giftbagList(data) {
  return axios({
    url: '/game/giftbag_list',
    method: 'post',
    data: data
  })
}

/* 子渠道列表 */
export function subChannel(data) {
  return axios({
    url: '/sub_channel/lists',
    method: 'post',
    data: data
  })
}

/* 子渠道添加修改 */
export function changePromote(data, url) {
  return axios({
    url: url,
    method: 'post',
    data: data
  })
}

/* 子渠道详情 */
export function promoteDetail(data) {
  return axios({
    url: '/sub_channel/promote_detail',
    method: 'post',
    data: data
  })
}

/* 游戏补点 */
export function gameMonthSubsidy(data) {
  return axios({
    url: '/user/gameMonthSubsidy',
    method: 'post',
    data: data
  })
}

/* 游戏补点领取 */
export function gameMonthSubsidyReceive(data) {
  return axios({
    url: '/user/gameMonthSubsidyReceive',
    method: 'post',
    data: data
  })
}

/* 游戏补点明细 */
export function gameMonthSubsidyDetail(data) {
  return axios({
    url: '/user/gameMonthSubsidyDetail',
    method: 'post',
    data: data
  })
}

/* 代充记录 */
export function rechargeRecord(data) {
  return axios({
    url: '/bhcoin/recharge_record',
    method: 'post',
    data: data
  })
}

/* 代充记录编辑 */
export function updateRecord(data) {
  return axios({
    url: '/bhcoin/update_recharge_record',
    method: 'post',
    data: data
  })
}

/* 下级提现 */
export function sonWithdrawal(data) {
  return axios({
    url: '/sub_channel/sonWithdrawal',
    method: 'post',
    data: data
  })
}

/* 下级提现通过驳回审核 */
export function changeSonWithdrawalStatus(data) {
  return axios({
    url: '/sub_channel/changeSonWithdrawalStatus',
    method: 'post',
    data: data
  })
}

/* 下级提现打款 */
export function sonWithdrawalPaid(data) {
  return axios({
    url: '/sub_channel/sonWithdrawalPaid',
    method: 'post',
    data: data
  })
}

/* 下级结算列表 */
export function finalList(data) {
  return axios({
    url: '/sub_channel/settlement',
    method: 'post',
    data: data
  })
}

/* 下级结算列表 结算/不结算 */
export function changeSettlementStatus(data) {
  return axios({
    url: '/sub_channel/changeSettlementStatus',
    method: 'post',
    data: data
  })
}

/* 下级结算列表 佣金结算 */
export function generateSettlement(data) {
  return axios({
    url: '/sub_channel/generateSettlement',
    method: 'post',
    data: data
  })
}

/* 结算汇总 */
export function settlementSummary(data) {
  return axios({
    url: '/sub_channel/settlementSummary',
    method: 'post',
    data: data
  })
}

/* 重新出包 */
export function gameApply(data) {
  return axios({
    url: '/game/reset_game_apply',
    method: 'post',
    data: data
  })
}

/* 代充选择用户 */
export function userLists(url, data) {
  return axios({
    url: url,
    method: 'post',
    data: data
  })
}

/* 用户折扣 */
export function rechargeDiscount(data) {
  return axios({
    url: '/bhcoin/user_recharge_discount',
    method: 'post',
    data: data
  })
}

/* 代充折扣 */
export function getRechargeDiscount(data) {
  return axios({
    url: '/bhcoin/get_recharge_discount',
    method: 'post',
    data: data
  })
}

/* 代充获取订单号 */
export function orderNum(data) {
  return axios({
    url: '/bhcoin/get_order_num',
    method: 'post',
    data: data
  })
}

/* 代充提交 */
export function rechargeSubmit(data) {
  return axios({
    url: '/bhcoin/user_recharge_submit',
    method: 'post',
    data: data
  })
}

/* 代充获取支付状态 */
export function orderStatus(data) {
  return axios({
    url: '/bhcoin/query_order_status',
    method: 'post',
    data: data
  })
}

/* 常见问题 */
export function commonQuestion(data) {
  return axios({
    url: '/user/common_question',
    method: 'post',
    data: data
  })
}

/* 后台所有玩家 */
export function adminAllUsers(data) {
  return axios({
    url: '/admin_function/all_users',
    method: 'post',
    data: data
  })
}

/* 后台用户折扣 */
export function adminDiscount(data) {
  return axios({
    url: '/admin_function/user_recharge_discount',
    method: 'post',
    data: data
  })
}

/* 后台发放获取订单号 */
export function adminOrderNum(data) {
  return axios({
    url: '/admin_function/get_grant_order_num',
    method: 'post',
    data: data
  })
}

/* 后台发放提交 */
export function grantSubmit(data) {
  return axios({
    url: '/admin_function/grant_submit',
    method: 'post',
    data: data
  })
}

/* 后台发放记录 */
export function grantRecord(data) {
  return axios({
    url: '/admin_function/bhcoin_grant_record',
    method: 'post',
    data: data
  })
}

/* 后台发放记录编辑提交 */
export function editRemark(data) {
  return axios({
    url: '/admin_function/edit_remark',
    method: 'post',
    data: data
  })
}

/* 后台渠道发放提交 */
export function promotePtb(data) {
  return axios({
    url: '/admin_function/promote_ptb_grant',
    method: 'post',
    data: data
  })
}

/* 后台渠道发放记录 */
export function promoteRecord(data) {
  return axios({
    url: '/admin_function/promote_ptb_grant_record',
    method: 'post',
    data: data
  })
}

/* 后台渠道发放记录编辑 */
export function editGrantRemark(data) {
  return axios({
    url: '/admin_function/edit_grant_remark',
    method: 'post',
    data: data
  })
}

/* 批量申请 */
export function batchCreateAccount(data) {
  return axios({
    url: '/user/batchCreateAccount',
    method: 'post',
    data: data
  })
}

/* 批量申请列表 */
export function batchCreateAccountLog(data) {
  return axios({
    url: '/user/batchCreateAccountLog',
    method: 'post',
    data: data
  })
}

/* 本渠道可申请游戏 */
export function alreadyApplyGameLists(data) {
  return axios({
    url: '/sub_channel/alreadyApplyGameLists',
    method: 'post',
    data: data
  })
}

/* 子渠道不可申请游戏 */
export function sonDisableGameLists(data) {
  return axios({
    url: '/sub_channel/sonDisableGameLists',
    method: 'post',
    data: data
  })
}

/* 子渠道不可申请游戏提交 */
export function sonDisableGameSet(data) {
  return axios({
    url: '/sub_channel/sonDisableGameSet',
    method: 'post',
    data: data
  })
}
/* 留存分析 */
export function playerRetain(data) {
  return axios({
    url: '/user/player_retain',
    method: 'post',
    data: data
  })
}
/* 留存分析详情 */
export function playerRetainDetail(data) {
  return axios({
    url: '/user/player_retain_detail',
    method: 'post',
    data: data
  })
}
/* 0.1折排行 */
export function discountGameRank(data) {
  return axios({
    url: '/game/discount_game_rank',
    method: 'post',
    data: data
  })
}
/* 游戏扶持，额外道具 */
export function gameDetailSupport(data) {
  return axios({
    url: '/game/game_detail_support',
    method: 'post',
    data: data
  })
}

/* 一键领取补点 */
export function gameMonthSubsidyBatchReceive(data) {
  return axios({
    url: '/user/gameMonthSubsidyBatchReceive',
    method: 'post',
    data: data
  })
}



// WEBPACK FOOTER //
// ./src/api/home.js